import { FC, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';

import cn from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/cross.svg';

import Portal from './Portal';

interface Props {
  children: ReactNode | ((targetEl: HTMLElement | null) => ReactNode);
  className?: string;
  classes?: {
    root?: string;
    overlay?: string;
    dialog?: string;
    title?: string;
    closeButton?: string;
    body?: string;
    footer?: string;
  };
  footer?: ReactNode;
  isOpen: boolean;
  /** if undefined then close button will not be shown */
  onClose?: () => void;
  title?: ReactNode;
  variant?: 'auto-width' | 'small' | 'medium' | 'large';
}

const Dialog: FC<Props> = ({ children, classes, className, footer, isOpen, onClose, title, variant }) => {
  return (
    <CSSTransition in={isOpen} classNames='fade' timeout={300} unmountOnExit>
      <Portal rootId='dialogs'>
        {(modalTargetEl) => (
          <div className={cn('dialog__wrapper', className, classes?.root)}>
            <div className={cn('dialog__overlay', classes?.overlay)} />
            <div
              className={cn('dialog', classes?.dialog, {
                'dialog--auto-width': variant === 'auto-width',
                'dialog--sm': variant === 'small',
                'dialog--md': variant === 'medium',
                'dialog--large': variant === 'large',
              })}
            >
              {title && <div className={cn('dialog__title', classes?.title)}>{title}</div>}
              {onClose && (
                <button className={cn('dialog__close', classes?.closeButton)} onClick={onClose}>
                  <CloseIcon />
                </button>
              )}
              <div className={cn('dialog__body', classes?.body)}>
                {typeof children === 'function' ? children(modalTargetEl) : children}
              </div>
              {footer && <div className={cn('dialog__footer', classes?.footer)}>{footer}</div>}
            </div>
          </div>
        )}
      </Portal>
    </CSSTransition>
  );
};

export default Dialog;
